// Author: T4professor

import {Component} from '@angular/core';
import {ICellRendererAngularComp} from 'ag-grid-angular';

@Component({
    selector: 'app-button-renderer2',
    template: `
    <button class="font-sans-3xs usa-button usa-button--accent-warm" (click)="onClick($event)">{{label}}</button>
  `
    // <button type="btn btn-primary w-auto" class = "fas fa-upload" color = "primary" (click)="onClick($event)">{{label}}</button>
    ,
    standalone: false
})

export class ButtonRendererComponent2 implements ICellRendererAngularComp {

  params;
  label: string;

  agInit(params): void {
    this.params = params;
    this.label = this.params.label || null;
  }

  refresh(params?: any): boolean {
    return true;
  }

  onClick($event) {
    if (this.params.onClick instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data
        // ...something
      };
      this.params.onClick(params);
    }
  }
}
